import { parseNumber } from '@/shared/components/form/parse-number';
import { t } from '@/shared/i18n/t';
import { addMonths } from '@/shared/lib/dates/add-months';
import { formatDate } from '@/shared/lib/dates/format-date';
import { isIsoDate } from '@/shared/lib/dates/is-iso-date';

export function shelfLifeHint(months: string, purchasedOn: string): string {
  const value = parseNumber(months);
  if (!value || !Number.isInteger(value) || !isIsoDate(purchasedOn))
    return t('Counted from the purchase date');
  return t('Until {date}, counting from the purchase', { date: formatDate(addMonths(purchasedOn, value)) });
}
